/** Rubber stamps (05 §10): the mission result on the debrief, and status marks on dossiers. */

import './chrome.css';
import type { MissionResult } from '../../../sim/types';
import { el } from '../dom';

export type StampTone = 'green' | 'amber' | 'red';

export interface StampSpec {
  text: string;
  tone: StampTone;
}

/** The result stamp (08 §2.9). Pure. */
export function resultStamp(result: Pick<MissionResult, 'outcome' | 'objectiveComplete'>): StampSpec {
  switch (result.outcome) {
    case 'extracted':
      return result.objectiveComplete
        ? { text: 'MISSION ACCOMPLISHED', tone: 'green' }
        : { text: 'MISSION FAILED', tone: 'amber' };
    case 'kia':
      return { text: 'KILLED IN ACTION', tone: 'red' };
    case 'captured':
      return { text: 'CAPTURED', tone: 'red' };
    case 'walkedOut':
      return { text: 'MISSING IN ACTION', tone: 'amber' };
    case 'scrubbed':
      return { text: 'MISSION SCRUBBED', tone: 'amber' };
  }
}

/** A stamp element; `small` is the dossier size (`KIA`, `POW`, `VETERAN`). */
export function stamp(spec: StampSpec, small = false): HTMLElement {
  const node = el('div', `menu-stamp menu-stamp-${spec.tone}${small ? ' menu-stamp-small' : ''}`, spec.text);
  return node;
}
